import { Component, OnInit } from '@angular/core';
import { CurrentPortfolio } from 'src/app/models/current-portfolio.model';
import { Subscription } from 'rxjs';
import { ClustersService } from 'src/app/services/clusters.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { PositionKeepingAnalysis } from 'src/app/models/analysis/position-keeping-analysis.model';
import { TableUtil } from 'src/app/utils';

@Component({
  selector: 'app-position-keeping-performance',
  templateUrl: './position-keeping-performance.component.html',
  styleUrls: ['./position-keeping-performance.component.scss']
})
export class PositionKeepingPerformanceComponent implements OnInit {

  inceptionDate: Date;
  investmentDate: Date;
  lastDate: Date;

  currentInvestable: CurrentPortfolio;
  currentInvestableSubscription: Subscription;

  selectedPage:string = 'absolute';
  selectedAbsoluteTab: string = 'Returns';
  selectedRelativeTab: string = 'Excess Returns';

  investablePKA: PositionKeepingAnalysis;
  originalPRA;
  investablePRA;
  protectedPRA;
  benchmarkPRA;
  is_standalone: boolean = false;
  is_protected: boolean = true;

  categories: string[];
  category_names: string[];
  catNames = {
    '3m': '3m',
    '6m': '6m',
    '1y': '1Y',
    '3y': '3Y',
    '5y': '5Y',
    '10y': '10Y',
    'investment': 'Since investment',
  };

  constructor(private clustersService: ClustersService) { }

  ngOnInit(): void {
    this.subscribeToCurrentInvestable();
  }

  ngOnDestroy() {
    if(this.currentInvestableSubscription!=undefined) { this.currentInvestableSubscription.unsubscribe(); }
  }

  subscribeToCurrentInvestable() {
    this.currentInvestableSubscription = this.clustersService.currentInvestableSubject.subscribe(
      (investable_portfolio: CurrentPortfolio) => {
        this.inceptionDate = investable_portfolio.positionKeepingAnalysis.inception_date;
        this.investmentDate = investable_portfolio.positionKeepingAnalysis.investment_date;
        this.lastDate = investable_portfolio.positionKeepingAnalysis.last_date;
        this.investablePKA = investable_portfolio.positionKeepingAnalysis;
        this.categories = Object.keys(this.investablePKA.performance_risk.investable.returns);
        this.category_names = this.categories.map((cat)=>{return this.catNames[cat]});
        this.originalPRA = this.investablePKA.performance_risk.original;
        this.is_standalone = this.originalPRA ? false : true;
        this.investablePRA = this.investablePKA.performance_risk.investable;
        this.protectedPRA = this.investablePKA.performance_risk.protected;
        this.benchmarkPRA = this.investablePKA.performance_risk.benchmark;
      }
    );
    this.clustersService.emitCurrentInvestable();
  }

  onAbsoluteTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Returns':               this.selectedAbsoluteTab='Returns'; break;
      case 'Volatility':            this.selectedAbsoluteTab='Volatility'; break;
      case 'Sharpe ratio':          this.selectedAbsoluteTab='Sharpe ratio'; break;
      case 'Max Drawdown':          this.selectedAbsoluteTab='Max Drawdown'; break;
    }
  }

  onRelativeTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Excess Returns':         this.selectedRelativeTab='Excess Returns'; break;
      case 'Tracking Error':         this.selectedRelativeTab='Tracking Error'; break;
      case 'Information ratio':      this.selectedRelativeTab='Information ratio'; break;
      case 'Max Relative Drawdown':  this.selectedRelativeTab='Max Relative Drawdown'; break;
    }
  }

  exportTable(){
    TableUtil.exportToExcel("tableToExport");
  }

}
